import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtPostTrace(params) {
  return request(
    `${BASE_URL}/provider/common/workFlow/trace`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPutObtainTask(params) {
  return request(
    `${BASE_URL}/provider/common/workFlow/obtain`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetWorkFlowNodeDefinition(workFlowDefinitionId) {
  return request(
    `${BASE_URL}/provider/common/workflownodedefinition/list/${workFlowDefinitionId}`,
    METHOD.GET,
    null
  )
}
